import React, { Component } from 'react';
import { connect } from 'react-redux';

import NRG from './NRG/index.jsx';
import PlaceOrder from './PlaceOrder';
import Charts from './charts'

class Header extends Component {
  render(){
    let style = {color:'white',padding:0}
    return (
      <div className='row'>
        <div className="col s6" style={{color:'white',padding:0}}>
          <h6 style={{float:'left'}}>Place Order</h6>
          {this.renderImages()}
        </div>
        <div className="col s6" style={{color:'white',paddingLeft:'0.375rem'}}>
          <h6>Collateral Info</h6>
        </div>
      </div>
    )
  }
  renderImages(){
    let curr1 = this.props.orderType == 'BUY' ? this.props.market.denomination : this.props.market.asset
    let curr2 = this.props.orderType == 'SELL' ? this.props.market.denomination : this.props.market.asset
    return (
      <div style={{float:'right',marginRight:'10px',marginTop:'5px'}}>
        <img className='placeImg2' src={`http://borderless-internal.blockcollider.org.s3-website.us-east-2.amazonaws.com/${curr1.toLowerCase()}.png`} />
        <i className="material-icons placeArrow" >arrow_forward</i>
        <img className='placeImg' src={`http://borderless-internal.blockcollider.org.s3-website.us-east-2.amazonaws.com/${curr2.toLowerCase()}.png`}  />
      </div>
    )
  }
}


function mapStateToProps(state,props) {
  return {
    market: state.ui_marketplace.market,
    orderType: state.ui_marketplace.orderType
  };
}

export default connect(mapStateToProps, {})(Header);
